var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9564_14353)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.79321 13.3004C2.79321 13.8573 3.01446 14.3915 3.40829 14.7853C3.80212 15.1791 4.33626 15.4004 4.89321 15.4004H6.99321V14.0004H4.89321C4.70756 14.0004 4.52951 13.9266 4.39824 13.7954C4.26696 13.6641 4.19321 13.486 4.19321 13.3004V3.50039C4.19321 3.31474 4.26696 3.13669 4.39824 3.00542C4.52951 2.87414 4.70756 2.80039 4.89321 2.80039H14.6932C14.8789 2.80039 15.0569 2.87414 15.1882 3.00542C15.3195 3.13669 15.3932 3.31474 15.3932 3.50039V5.60039H9.09321C8.53626 5.60039 8.00212 5.82164 7.60829 6.21547C7.21446 6.60929 6.99321 7.14344 6.99321 7.70039V17.5004C6.99321 18.0573 7.21446 18.5915 7.60829 18.9853C8.00212 19.3791 8.53626 19.6004 9.09321 19.6004H18.8932C19.4502 19.6004 19.9843 19.3791 20.3781 18.9853C20.772 18.5915 20.9932 18.0573 20.9932 17.5004V7.70039C20.9932 7.14344 20.772 6.60929 20.3781 6.21547C19.9843 5.82164 19.4502 5.60039 18.8932 5.60039H16.7932V3.50039C16.7932 2.94344 16.572 2.40929 16.1781 2.01547C15.7843 1.62164 15.2502 1.40039 14.6932 1.40039H4.89321C4.33626 1.40039 3.80212 1.62164 3.40829 2.01547C3.01446 2.40929 2.79321 2.94344 2.79321 3.50039V13.3004ZM8.39321 7.70039C8.39321 7.51474 8.46696 7.33669 8.59824 7.20542C8.72951 7.07414 8.90756 7.00039 9.09321 7.00039H18.8932C19.0789 7.00039 19.2569 7.07414 19.3882 7.20542C19.5195 7.33669 19.5932 7.51474 19.5932 7.70039V17.5004C19.5932 17.686 19.5195 17.8641 19.3882 17.9954C19.2569 18.1266 19.0789 18.2004 18.8932 18.2004H9.09321C8.90756 18.2004 8.72951 18.1266 8.59824 17.9954C8.46696 17.8641 8.39321 17.686 8.39321 17.5004V7.70039Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9564_14353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2759,
    height: 21,
    fill: "white",
    transform: "translate(0.379395)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyWhite);
export default __webpack_public_path__ + "static/media/copy_white.35a0685e4c7e8632044d27a91a649085.svg";
export { ForwardRef as ReactComponent };